import dashboard from "../../assets/svg/iconSidebar/dashboard.svg";
import dashboardHover from "../../assets/svg/iconSidebar/hover-dashboard.svg";
import dashboardActive from "../../assets/svg/iconSidebar/active-dashboard.svg";
import Peoples from "../../assets/svg/iconSidebar/hover-Peoples.svg";
import PeoplesHover from "../../assets/svg/iconSidebar/Peoples.svg";
import PeoplesActive from "../../assets/svg/iconSidebar/PeopleActive.svg";
import CommodityServantHover from "../../assets/svg/iconSidebar/CommodityServant.svg";
import CommodityServantActive from "../../assets/svg/iconSidebar/active-commodityServant.svg";
import CommodityServant from "../../assets/svg/iconSidebar/hover-commodityServant.svg";
import Transaction from "../../assets/svg/iconSidebar/transaction.svg";
import TransactionHover from "../../assets/svg/iconSidebar/hover-transaction.svg";
import TransactionActive from "../../assets/svg/iconSidebar/active-transaction.svg";
import BankingActive from "../../assets/svg/iconSidebar/Active-Banking.svg";
import BankingHover from "../../assets/svg/iconSidebar/Banking.svg";
import Banking from "../../assets/svg/iconSidebar/Hover-Banking.svg";
import cheque from "../../assets/svg/iconSidebar/cheque.svg";
import chequeHover from "../../assets/svg/iconSidebar/hover-cheque.svg";
import chequeActive from "../../assets/svg/iconSidebar/active-cheque.svg";
import Inventory from "../../assets/svg/iconSidebar/Inventory.svg";
import InventoryHover from "../../assets/svg/iconSidebar/hover-Inventory.svg";
import InventoryActive from "../../assets/svg/iconSidebar/active-Inventory.svg";
import Accounting from "../../assets/svg/iconSidebar/Accounting.svg";
import AccountingHover from "../../assets/svg/iconSidebar/hover-Accounting.svg";
import AccountingActive from "../../assets/svg/iconSidebar/active-Accounting.svg";
import Others from "../../assets/svg/iconSidebar/sidebar-others.svg";
import OthersHover from "../../assets/svg/iconSidebar/sidebar-others-hover.svg";
import OthersActive from "../../assets/svg/iconSidebar/sidebar-others-active.svg";
import Chat from "../../assets/svg/iconSidebar/chat.svg";
import ChatActive from "../../assets/svg/iconSidebar/active-chat.svg";
import ChatHover from "../../assets/svg/iconSidebar/hover-chat.svg";
import ReportsActive from "../../assets/svg/iconSidebar/active-Reports.svg";
import Reports from "../../assets/svg/iconSidebar/Reports.svg";
import ReportsHover from "../../assets/svg/iconSidebar/hover-Reports.svg";
import Setting from "../../assets/svg/iconSidebar/Setting.svg";
import SettingActive from "../../assets/svg/iconSidebar/Setting-active.svg";
import SettingHover from "../../assets/svg/iconSidebar/Setting-hover.svg";
import Filemanager from "../../assets/svg/iconSidebar/Filemanager.svg";
import FilemanagerActive from "../../assets/svg/iconSidebar/FilemanagerActive.svg";
import FilemanagerHover from "../../assets/svg/iconSidebar/FilemanagerHover.svg";
import ArchiveActive from "../../assets/svg/Archive/Blue.svg";
import Archive from "../../assets/svg/Archive/gray.svg";
import ArchiveHover from "../../assets/svg/Archive/White.svg";
import ProductionActive from "../../assets/svg/iconSidebar/production-blue.svg";
import Production from "../../assets/svg/iconSidebar/production-gray.svg";
import ProductionHover from "../../assets/svg/iconSidebar/production-white.svg";
import SmsPanelActive from "../../assets/svg/iconSidebar/sms-blue.svg";
import SmsPanel from "../../assets/svg/iconSidebar/sms-grey.svg";
import SmsPanelHover from "../../assets/svg/iconSidebar/sms-white.svg";
import MoaddianActive from "../../assets/svg/Moadian/blue.svg";
import Moaddian from "../../assets/svg/Moadian/Gray.svg";
import MoaddianHover from "../../assets/svg/Moadian/white.svg";
import shortid from "shortid";

export const itemsSideBarImage = {
    Peoples: Peoples,
    CommodityServant: CommodityServant,
    Banking: Banking,
    Transaction: Transaction,
    Inventory: Inventory,
    cheque: cheque,
    Accounting: Accounting,
    Reports: Reports,
    Others: Others,
    Filemanager: Filemanager,
    Setting: Setting,
    Manufacture: Production,
    archive: Archive,
    moaddian: Moaddian,
    Support: Chat,
    SmsPanel: SmsPanel
};

const itemsSidebar = {
    name: "routerName",
    items: [
        {
            id: shortid.generate(),
            name: "داشبورد",
            url: "/dashboard",
            urlName: "Dashboard",
            key: "dashboard",
            img: dashboard,
            imgHover: dashboardHover,
            imgActive: dashboardActive,
            icon: ["Plus", "Save"],
        },
        {
            id: shortid.generate(),
            name: "اشخاص",
            url: "",
            key: "Peoples",
            urlName: null,
            img: Peoples,
            imgHover: PeoplesHover,
            imgActive: PeoplesActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "افزودن شخص",
                    shortName: "ثبت شخص",
                    url: "/persons/add",
                    urlName: "AddPersons",
                    img: "",
                    icon: ["Plus", "Save"],
                    show: true,
                    permission: "customerSave,personnelSave,providerSave,providerEdit,personnelEdit,customerEdit",
                },
                {
                    id: shortid.generate(),
                    name: "لیست اشخاص",
                    shortName: "اشخاص",
                    url: "/persons",
                    urlName: "Persons",
                    img: "",
                    icon: ["Other", "Save", "Delete", "Edit"],
                    show: true,
                    permission: "providerShow,personnelShow,customerShow",
                },
                {
                    id: shortid.generate(),
                    name: "slot",
                },
                // {
                //   id: shortid.generate(),
                //   name: "افزودن کاربر",
                //   shortName: "ثبت کاربر",
                //   url: "/users/add",
                //   urlName: "AddUser",
                //   img: "",
                //   icon: ["Save"],
                //   show: true,
                //   permission: "settingUserManagement",
                // },
                // {
                //   id: shortid.generate(),
                //   name: "لیست کاربران",
                //   shortName: "کاربران",
                //   url: "/users",
                //   urlName: "UpdateUser",
                //   img: "",
                //   icon: ["Save", "Delete"],
                //   show: true,
                //   permission: "settingUserManagement",
                // },
                {
                    id: shortid.generate(),
                    name: "slot",
                },
                {
                    id: shortid.generate(),
                    name: "لیست سهامداران",
                    shortName: "سهامداران",
                    url: "/shareholders",
                    urlName: "Shareholders",
                    img: "",
                    icon: ["Save", "Add"],
                    show: true,
                    permission: "shareholderSave,shareholderShow",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "محصولات",
            url: "",
            urlName: null,
            key: "CommodityServant",
            img: CommodityServant,
            imgHover: CommodityServantHover,
            imgActive: CommodityServantActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "افزودن محصول",
                    shortName: "ثبت محصول",
                    url: "/products/add",
                    urlName: "AddProduct",
                    img: "",
                    icon: ["Save", "NewFile"],
                    show: true,
                    permission: "productSave",
                },
                {
                    id: shortid.generate(),
                    name: "لیست محصولات",
                    shortName: "محصولات",
                    url: "/products",
                    urlName: "ShowProductServices",
                    img: "",
                    icon: ["Delete", "Edit", "NewFile"],
                    show: true,
                    permission: "productShow",
                },
                {
                    id: shortid.generate(),
                    name: "لیست قیمت",
                    shortName: "لیست قیمت",
                    url: "/products/prices",
                    urlName: "ShowProductServices",
                    img: "",
                    icon: ["Delete", "Edit", "NewFile"],
                    show: true,
                    permission: "pricePlanEdit,pricePlanSave,pricePlanShow",
                },
                {
                    id: shortid.generate(),
                    name: "ویژگی محصول",
                    shortName: "ویژگی محصول",
                    url: "/productsproperty",
                    urlName: "productProperty",
                    img: "",
                    icon: ["Delete", "Edit", "NewFile"],
                    show: true,
                    permission: "productPropertyEdit,productPropertySave,productPropertyShow",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "مالی و بانکداری",
            url: "",
            urlName: null,
            key: "Banking",
            img: Banking,
            imgHover: BankingHover,
            imgActive: BankingActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "افزودن حساب",
                    shortName: "ثبت حساب",
                    url: "/financials/add",
                    urlName: "AddBanks",
                    img: "",
                    icon: ["Plus", "Save"],
                    show: false,
                    permission: "accountingSave",
                },
                {
                    id: shortid.generate(),
                    name: "لیست حساب ها",
                    shortName: "حساب ها",
                    url: "/financials",
                    urlName: "Financials",
                    img: "",
                    icon: ["Delete", "Edit", "Plus"],
                    show: true,
                    permission: "accountingShow",
                },
                {
                    id: shortid.generate(),
                    name: "slot",
                },
                {
                    id: shortid.generate(),
                    name: "ثبت انتقال",
                    shortName: "ثبت انتقال",
                    url: "/transfers/add",
                    urlName: "Transfer",
                    img: "",
                    icon: ["Save", "NewFile"],
                    show: true,
                    permission: "transferSave",
                },
                {
                    id: shortid.generate(),
                    name: "لیست انتقال ها",
                    shortName: "انتقال ها",
                    url: "/transfers",
                    urlName: "Transfers",
                    img: "",
                    icon: ["Other", "Delete", "Edit", "Show", "NewFile"],
                    show: true,
                    permission: "transferShow",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "فاکتورها و تراکنش ها",
            url: "",
            urlName: null,
            key: "Transaction",
            img: Transaction,
            imgHover: TransactionHover,
            imgActive: TransactionActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "ثبت فاکتور",
                    shortName: "ثبت فاکتور",
                    url: "/factors/add",
                    urlName: "AddFactor",
                    img: "",
                    icon: ["Plus", "Save"],
                    show: true,
                    permission: "saleSave,buySave,saleReturnSave,buyReturnSave,wasteSave",
                },
                // {
                //     id: shortid.generate(),
                //     name: "فاکتور فروشگاهی",
                //     shortName: "ثبت فاکتور",
                //     url: "/shopFactor",
                //     urlName: "/shopFactor",
                //     img: "",
                //     icon: ["Plus", "Save"],
                //     show: true,
                //     permission: "saleSave",
                // },
                {
                    id: shortid.generate(),
                    name: "لیست فاکتور ها",
                    shortName: "فاکتورها",
                    url: "/factors",
                    urlName: "AddFactors",
                    img: "",
                    icon: ["Plus", "Save"],
                    show: true,
                    permission: "saleShow,buyShow,wasteShow,buyReturnShow,saleReturnShow",
                },
                // {
                //   id: shortid.generate(),
                //   name: "بروزرسانی دریافت",
                //   url: "/updateReceived",
                //   urlName: "UpdateReceived",
                //   img: "",
                //   icon: ["Save", "Delete"],
                //   show: false,
                // },
                {
                    id: shortid.generate(),
                    name: "ثبت تراکنش",
                    shortName: "ثبت تراکنش",
                    url: "/transactions/add",
                    urlName: "AddTransaction",
                    img: "",
                    icon: ["Show", "Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "paymentSave,costSave,incomeSave,receiveSave",
                },
                {
                    id: shortid.generate(),
                    name: "لیست تراکنش ها",
                    shortName: "تراکنش ها",
                    url: "/transactions",
                    urlName: "AddTransactions",
                    img: "",
                    icon: ["Show", "Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "paymentShow,receiveShow,incomeShow,costShow",
                },
                {
                    id: shortid.generate(),
                    name: "ثبت اقساط",
                    shortName: "ثبت اقساط",
                    url: "/installments/add",
                    urlName: "AddInstallment",
                    img: "",
                    icon: ["Show", "Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "installmentSave",
                },
                {
                    id: shortid.generate(),
                    name: "لیست اقساط",
                    shortName: "اقساط",
                    url: "/installments",
                    urlName: "AddInstallments",
                    img: "",
                    icon: ["Show", "Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "installmentShow",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "انبارداری",
            url: "",
            urlName: null,
            key: "Inventory",
            img: Inventory,
            imgHover: InventoryHover,
            imgActive: InventoryActive,
            condition: "haveWarehouse",
            subItem: [
                {
                    id: shortid.generate(),
                    name: "افزودن انبار",
                    shortName: "ثبت انبار",
                    url: "/inventories/add",
                    urlName: "AddInventory",
                    img: "",
                    icon: ["Plus", "Save"],
                    show: true,
                    permission: "warehouseSave",
                },
                {
                    id: shortid.generate(),
                    name: "لیست انبارها",
                    shortName: "انبارها",
                    url: "/inventories",
                    urlName: "Inventories",
                    img: "",
                    icon: ["Delete", "Edit", "Plus"],
                    show: true,
                    permission: "warehouseShow",
                },
                {
                    id: shortid.generate(),
                    name: "slot",
                },
                {
                    id: shortid.generate(),
                    name: "ثبت رسید/حواله",
                    shortName: "ثبت سند",
                    url: "/remittance/add",
                    urlName: "AddRemittance",
                    img: "",
                    icon: ["Save", "NewFile"],
                    show: true,
                    permission: "WarehouseRemittanceSave",
                },
                {
                    id: shortid.generate(),
                    name: "رسید و حواله های انبار",
                    shortName: "حواله انبار",
                    url: "/remittance",
                    urlName: "AddRemittance",
                    img: "",
                    icon: ["Other", "Delete", "Edit", "Show", "NewFile"],
                    show: true,
                    permission: "WarehouseRemittanceShow",
                },
                {
                    id: shortid.generate(),
                    name: "موجودی انبار",
                    shortName: "موجودی انبار",
                    url: "/inventories/supply",
                    urlName: "InventorySupply",
                    img: "",
                    icon: ["Other", "Delete", "Edit", "Show", "NewFile"],
                    show: true,
                    permission: "warehouseShow",
                },
                {
                    id: shortid.generate(),
                    name: "کسری انبار",
                    shortName: "کسری انبار",
                    url: "/inventories/shortage",
                    urlName: "InventoryShortage",
                    img: "",
                    icon: ["Other", "Delete", "Edit", "Show", "NewFile"],
                    show: true,
                    permission: "warehouseShow",
                },
                {
                    id: shortid.generate(),
                    name: "انبارگردانی",
                    shortName: "انبارگردانی",
                    url: "/stockTaking",
                    urlName: "StockTaking",
                    img: "",
                    icon: ["Other", "Delete", "Edit", "Show", "NewFile"],
                    show: true,
                    permission: "warehouseShow",
                },
                // {
                //   id: shortid.generate(),
                //   name: "موجودی کالا",
                //   url: "/showInventory",
                //   urlName: "ShowInventory",
                //   img: "",
                //   icon: ["PDF", "EXL", "Printer"],
                //   show: true,
                // },
                // {
                //   id: shortid.generate(),
                //   name: "موجودی تمامی انبارها",
                //   url: "/showIW",
                //   urlName: "showInventoryWarehouses",
                //   img: "",
                //   icon: ["PDF", "EXL", "Printer"],
                //   show: true,
                // },
                // {
                //   id: shortid.generate(),
                //   name: "slot",
                // },
            ],
        },
        {
            id: shortid.generate(),
            name: "چک",
            url: "",
            urlName: null,
            key: "cheque",
            img: cheque,
            imgHover: chequeHover,
            imgActive: chequeActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "چک های دریافتی",
                    shortName: "چک دریافتی",
                    url: "/cheques/receive",
                    urlName: "ReceivedCheques",
                    img: "",
                    icon: [],
                    show: true,
                    permission: "receivedchequeShow",
                },
                {
                    id: shortid.generate(),
                    name: "چک های پرداختی",
                    shortName: "چک پرداختی",
                    url: "/cheques/payment",
                    urlName: "PaymentCheques",
                    img: "",
                    icon: [],
                    show: true,
                    permission: "paymentchequeShow",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "حسابداری",
            url: "",
            urlName: null,
            key: "Accounting",
            img: Accounting,
            imgHover: AccountingHover,
            imgActive: AccountingActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "ثبت سند حسابداری",
                    shortName: "ثبت سند",
                    url: "/accounting/add",
                    urlName: "AddDocument",
                    img: "",
                    icon: ["Save", "RateConversion", "NewFile"],
                    show: true,
                    permission: "accountingSave",
                },
                {
                    id: shortid.generate(),
                    name: "اسناد حسابداری",
                    shortName: "اسناد",
                    url: "/accounting",
                    urlName: "Accountings",
                    img: "",
                    icon: ["Other", "Delete", "Edit", "NewFile"],
                    show: true,
                    permission: "accountingShow",
                },
                {
                    id: shortid.generate(),
                    name: "تراز افتتاحیه",
                    shortName: "تراز افتتاحیه",
                    url: "/openingBalance",
                    urlName: "OpeningBalance",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "accountingShow",
                },
                {
                    id: shortid.generate(),
                    name: "بستن سال مالی",
                    shortName: "بستن سال مالی",
                    url: "/closeFiscalYear",
                    urlName: "closeFiscalYear",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "accountingSave",

                },
                {
                    id: shortid.generate(),
                    name: "سند حقوق",
                    shortName: "سند حقوق",
                    url: "/salary",
                    urlName: "SalaryDocument",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "accountingSave",

                },
                {
                    id: shortid.generate(),
                    name: "جدول حساب ها",
                    shortName: "جدول حساب ها",
                    url: "/accountingType",
                    urlName: "AccountingType",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "reportsAccounts",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "پنل پیامک",
            url: "",
            urlName: null,
            key: "SmsPanel",
            img: SmsPanel,
            imgHover: SmsPanelHover,
            imgActive: SmsPanelActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "پنل پیامک",
                    shortName: "پنل پیامک",
                    url: "/wallet",
                    urlName: "Wallet",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "branchShow",
                    condition: "hasSmsPanel",
                },
                {
                    id: shortid.generate(),
                    name: "تاریخچه پیامک",
                    shortName: "تاریخچه پیامک",
                    url: "/smsHistory",
                    urlName: "SmsHistory",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "branchShow",
                    condition: "hasSmsPanel",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "تولید",
            url: "",
            urlName: null,
            key: "Manufacture",
            img: Production,
            imgHover: ProductionHover,
            imgActive: ProductionActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "ایجاد فرمول تولید",
                    shortName: "فرمول تولید",
                    url: "/manufacture/formulas/add",
                    urlName: "ManufactureFormula",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "productionFormulaSave"

                },
                {
                    id: shortid.generate(),
                    name: "لیست فرمول تولید",
                    shortName: "لیست فرمول",
                    url: "/manufacture/formulas",
                    urlName: "ManufactureFormulas",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "productionFormulaShow"
                },
                {
                    id: shortid.generate(),
                    name: "سفارش تولید",
                    shortName: "سفارش تولید",
                    url: "/manufacture/orders/add",
                    urlName: "ManufactureOrder",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "productionOrderSave"
                },
                {
                    id: shortid.generate(),
                    name: "لیست سفارش تولید",
                    shortName: "لیست تولید",
                    url: "/manufacture/orders",
                    urlName: "ManufactureOrders",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "productionOrderShow"
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "آرشیو اسناد",
            shortName: "آرشیو اسناد",
            url: "/archive",
            urlName: "archive",
            key: "archive",
            img: Archive,
            permission: "documentShow,documentSave,documentDelete",
            imgHover: ArchiveHover,
            imgActive: ArchiveActive,
            // businessAccess:"isDocumentAccess"
        },
        {
            id: shortid.generate(),
            name: "سامانه مؤدیان",
            shortName: "سامانه مؤدیان",
            url: "/moaddian",
            urlName: "moaddian",
            key: "moaddian",
            img: Moaddian,
            imgHover: MoaddianHover,
            imgActive: MoaddianActive,
            permission: `moaddianShow,moaddianSave,moaddianEdit,moaddianDelete,moaddianInquiry`
        },
        {
            id: shortid.generate(),
            name: "گزارشات",
            shortName: "گزارشات",
            url: "/reports",
            urlName: "ShowReports",
            key: "Reports",
            img: Reports,
            imgHover: ReportsHover,
            imgActive: ReportsActive,
            permission: `reportsBalanceSheet,
reportsProfitAndLoss,
reportsBranchAccountCard,
reportsProjectAccountCard,
reportsCapitalInvoice,
reportsNewspaperOffice,
reportsAccounts,
reportsTestableLevel,
reportsReviewAccounts,
reportsDebtorsAndCreditors,
reportsIndividualsAccount,
reportsProductStore,
reportsCommoditySccountCard,
reportsSaleByProduct,
reportsBuyByProduct,
reportsSaleByFactor,
reportsBuyByFactor,
reportsTax,
reportsProfitFactor,
reportsFactorSummaryByPerson,
reportsAccounts,
reportsBankAccountTurnover,
reportsCashierAccountTurnover,
reportsFundAccountTurnover,
reportsUserActivity`,
            icon: ["Plus", "Save"],
        },
        {
            id: shortid.generate(),
            name: "مدیریت اطلاعات",
            shortName: "اطلاعات",
            url: "/sync",
            urlName: "Sync",
            key: "Filemanager",
            img: Filemanager,
            imgHover: FilemanagerHover,
            imgActive: FilemanagerActive,
        },
        {
            id: shortid.generate(),
            name: "سایر",
            url: "",
            urlName: null,
            key: "Others",
            img: Others,
            imgHover: OthersHover,
            imgActive: OthersActive,
            subItem: [
                {
                    id: shortid.generate(),
                    name: "لیست پروژه ها",
                    shortName: "پروژه ها",
                    url: "/projects",
                    urlName: "Projects",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "projectShow",
                },
                {
                    id: shortid.generate(),
                    name: "لیست شعب",
                    shortName: "شعب",
                    url: "/branches",
                    urlName: "Branches",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "branchShow",
                },
                {
                    id: shortid.generate(),
                    name: "لیست مرکز هزینه",
                    shortName: "مرکز های هزینه",
                    url: "/costCenters",
                    urlName: "CostCenters",
                    img: "",
                    icon: ["Save", "Delete", "Edit", "Other"],
                    show: true,
                    permission: "costCenterShow",
                },
            ],
        },
        {
            id: shortid.generate(),
            name: "تنظیمات",
            shortName: "تنظیمات",
            url: "/settings",
            urlName: "Setting",
            key: "Setting",
            img: Setting,
            imgHover: SettingHover,
            imgActive: SettingActive,
        },
        // {
        //     id: shortid.generate(),
        //     name: "پنل پیامکی",
        //     url: "/smsPanel",
        //     urlName: "SMSPanel",
        //     img: Setting,
        //     imgHover: SettingHover,
        //     imgActive: SettingActive,
        // },
        {
            id: shortid.generate(),
            name: "پشتیبانی",
            shortName: "پشتیبانی",
            link: "https://support.chortke.app",
            // link: "http://localhost:3000",
            key: "Support",
            urlName: Chat,
            img: Chat,
            imgHover: ChatHover,
            imgActive: ChatActive,
        },
        // {
        //     id: shortid.generate(),
        //     name: "انتقال دیتا",
        //     shortName: "انتقال دیتا",
        //     url: "/multiTenant",
        //     key: "multiTenant",
        //     urlName: Chat,
        //     img: Chat,
        //     imgHover: ChatHover,
        //     imgActive: ChatActive,
        // },
    ],
};

export default itemsSidebar;
